import CardModifier from './CardModifier';
import GameObject from '../../../../GameObject/GameObject';
import Point from '../../../../Utility/Point';
import Text from '../../../Text';
import { addDragonbonesResources } from 'Utility/Resource/ResourceHelper';
import { DRAGONBONES_PATH } from 'Constants/Dragonbones';
import Armature from 'Prototype/Armature';
import { ITextData } from 'Prototype/UI/UIItem';

export const TOMATO_BOMB_ARMATURE_NAME = 'tomato_bomb_armature';
export const TOMATO_BOMB_TURN_COUNT_NAME = 'turn_count';
export const TOMATO_BOMB_RED_TURN_COUNT_NAME = 'turn_count_red';

export default class BombModifier extends CardModifier {
    onCreate(params: any): void {
        super.onCreate(params);

        const bombArmature = GameObject.Instantiate(Armature, {
            name: TOMATO_BOMB_ARMATURE_NAME,
            dragonbonesName: 'tomato_bomb',
            armatureName: 'Armature',
            animationName: 'burning',
            playOnStart: true,
            anchor: new Point(0.5, 0.5),
            position: new Point(-40, -75),
        });

        const turnCount: GameObject = GameObject.Instantiate(Text, {
            name: TOMATO_BOMB_TURN_COUNT_NAME,
            text: String(params.properties.timer),
            style: {
                fontFamily: 'FrancoisOne',
                fontSize: 33,
                fill: '#fcffd9',
                align: 'center',
            },
            align: 'center',
            anchor: new Point(0.5, 0.5),
            position: new Point(-4, 18),
        });

        const turnCountRed: GameObject = GameObject.Instantiate(Text, {
            name: TOMATO_BOMB_RED_TURN_COUNT_NAME,
            text: String(params.properties.timer),
            style: {
                fontFamily: 'FrancoisOne',
                fontSize: 33,
                fill: '#FF6C6C',
                align: 'center',
            },
            align: 'center',
            anchor: new Point(0.5, 0.5),
            position: new Point(-4, 18),
            alpha: 0,
        });

        bombArmature.addChild(turnCount);
        bombArmature.addChild(turnCountRed);

        this.addChild(bombArmature);
    }

    public static async preload(): Promise<void> {
        addDragonbonesResources("tomato_bomb", `${DRAGONBONES_PATH}/Tomato/`);
    }

    protected turnCountParams: ITextData = {
        name: 'turn_count',
        text: '5',
        layout: {
            anchors: [0, 0, 0, 0],
            pivot: [1, 1],
            offsets: [28, 10, 28, 10],
            scale: [1, 1],
        },
        style: {
            font: 'FrancoisOne',
            fill: '#fcffd9',
            fontSize: '33px',
        },
    };
}
